import { InputComponentType } from "../../../utils/enums";

export const getCertificationFields = (isAdd = false) => [
  {
    name: "employee",
    label: "Employee #",
    required: true,
    component: InputComponentType.Dropdown,
  },
  {
    name: "certificationType",
    label: "Certification Type",
    component: InputComponentType.FreeTextDropdown,
  },
  {
    name: "comments",
    label: "Comments",
    component: InputComponentType.TextField,
  },
  {
    name: "dateObtained",
    label: "Obtained",
    component: InputComponentType.DatePicker,
  },
  {
    name: "expireDate",
    label: "Expiration",
    component: InputComponentType.DatePicker,
  },
  {
    name: "certificateNumber",
    label: "Certificate #",
    type: "text",
    component: InputComponentType.TextField,
    isDisabled: (formValues) => !!formValues.id,
    isIdField: true,
  },
];
